export default "__VITE_ASSET__CpfQLIRa__"